import React, { ReactElement } from 'react';
import { useMessageGetter } from '@messageformat/react';
import FeedbackMessage from '../FeedbackMessage';
import Selection from './Selection';
import QuestionTile from '../QuestionTile';

interface QuestionProps {
  number: string;
  correctAnswer: string;
  options: string[];
  selectedOptions: string[];
  setSelectedOptions: React.Dispatch<React.SetStateAction<string[]>>;
  updateAnswers: (value: number) => void;
}

const DropdownQuestionTile = ({
  number,
  correctAnswer,
  options,
  selectedOptions,
  setSelectedOptions,
  updateAnswers = () => {},
}: QuestionProps): ReactElement => {
  const getMessage = useMessageGetter('course3.task2');
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    const { value } = event.target;
    const index = Number(number) - 1;
    const copy = [...selectedOptions];

    // Remove other selection with the same value
    const existingIndex = selectedOptions.indexOf(value);
    if (existingIndex !== -1) {
      copy[existingIndex] = '';
    }

    // Place new value to selection
    copy[index] = value;
    setSelectedOptions(copy);

    if (copy[Number(number) - 1] === correctAnswer) {
      updateAnswers(1);
    }
  };

  return (
    <QuestionTile
      number={number}
      question={getMessage(`question${number}.text`)?.split('\n\n')}
    >
      <Selection
        index={Number(number) - 1}
        options={options}
        selectedOptions={selectedOptions}
        onChange={handleChange}
        label={getMessage('question_label')}
      />
      <FeedbackMessage
        hasAnswered={selectedOptions[Number(number) - 1] !== null}
        isCorrect={selectedOptions[Number(number) - 1] === correctAnswer}
      />
    </QuestionTile>
  );
};

export default DropdownQuestionTile;
